module.exports = __webpack_public_path__ + "img/ky.597578bc.svg";